import uuid from 'react-uuid';
import { Stack, Text } from 'components/ui';
import DailyNavFtpConfig from 'pages/Firms/pages/DailyNavSettings/DailyNavFtpConfig';
import DailyNavTemplateMapper from 'pages/Firms/pages/DailyNavSettings/DailyNavTemplateMapper';
import { FirmStepProps } from './FirmStep.props';
import { editRecipientRows, isValidEmail } from '../hooks/useFirmSetupForm';

type FirmDeliveryStepProps = FirmStepProps & {
  templateFile: File | null;
  isUploadingTemplate: boolean;
  onTemplateFileChange: (file: File | null) => void;
};

const FirmDeliveryStep = ({
  form,
  disabled,
  templateFile,
  isUploadingTemplate,
  onTemplateFileChange,
}: FirmDeliveryStepProps) => {
  const { draft, update } = form;

  return (
    <Stack spacing={3}>
      <Text variant="body2" color="text.secondary">
        Optional: a report template and SFTP delivery for the report file. Skip these if the firm doesn&apos;t need a
        custom file yet. Everything here can be changed later in Daily NAV Settings.
      </Text>
      <DailyNavTemplateMapper
        disabled={disabled}
        isUploading={isUploadingTemplate}
        templateFile={templateFile}
        reportTemplateId={draft.reportTemplateId}
        reportTemplateFilename={draft.reportTemplateFilename}
        reportColumnMappings={draft.reportColumnMappings}
        reportMappingFields={draft.reportMappingFields}
        onFileChange={onTemplateFileChange}
        onReportColumnMappingsChange={updater => update('reportColumnMappings', updater(draft.reportColumnMappings))}
      />
      <DailyNavFtpConfig
        disabled={disabled}
        ftpHost={draft.ftpHost}
        ftpPort={draft.ftpPort}
        ftpPath={draft.ftpPath}
        ftpUsername={draft.ftpUsername}
        onFtpHostChange={value => update('ftpHost', value)}
        onFtpPortChange={value => update('ftpPort', value)}
        onFtpPathChange={value => update('ftpPath', value)}
        onFtpUsernameChange={value => update('ftpUsername', value)}
        deliveryRecipients={draft.deliveryRecipients}
        onAddDeliveryRecipient={() =>
          update('deliveryRecipients', [...draft.deliveryRecipients, { email: '', key: uuid() }])
        }
        onRemoveDeliveryRecipient={index =>
          update(
            'deliveryRecipients',
            draft.deliveryRecipients.filter((_, rowIndex) => rowIndex !== index)
          )
        }
        onDeliveryRecipientChange={(index, value) =>
          update('deliveryRecipients', editRecipientRows(draft.deliveryRecipients, index, value))
        }
        isDeliveryEmailInvalid={email => Boolean(email) && !isValidEmail(email)}
      />
    </Stack>
  );
};

export default FirmDeliveryStep;
